import React, { useState } from 'react'
import Field from './Field'
import classNames from 'classnames'
import styles from './TextArea.module.scss'

const TextArea = React.forwardRef(({ inline, className, infoText, forceInfoText, ...rest }, ref) => {
	const [info, setInfo] = useState('')
	return(
		<div className={classNames(styles.root, { inline: inline, [className]: className })}>
			<Field
				{...rest}
				onSwitchInfo={e => setInfo(info ? '' : infoText)}
				infoText={forceInfoText || info} />
		</div>
	)
})

export default TextArea
